module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer_id"
    }
  }, [_c('u-animate-container', {
    staticClass: "wow-wrap"
  }, [_c('div', {
    staticClass: "footer_map_section"
  }, [_c('span', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypoint2,
        options: _vm.intersectionOptions2
      }),
      expression: "{ active: true, callback: onWaypoint2, options: intersectionOptions2 }"
    }],
    attrs: {
      "id": "fishouter"
    }
  }, [(_vm.props.acf.jelly_fish) ? _c('img', {
    staticClass: "ornament",
    attrs: {
      "id": "starfish",
      "src": _vm.props.acf.jelly_fish,
      "alt": "",
      "width": "106"
    }
  }) : _vm._e()]), _c('u-animate', {
    staticClass: "map_wrap",
    attrs: {
      "name": "bounceInUp",
      "delay": "1.5s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.props.acf.map_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.map_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('u-animate', {
    staticClass: "location_ft",
    attrs: {
      "name": "fadeInLeftBig",
      "delay": "0.5s",
      "duration": "1.6s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [_c('div', {
    staticClass: "fbWidget"
  }, [_c('div', {
    staticClass: "fb-page fb_iframe_widget"
  }, [_c('span', [(_vm.props.acf.fb_iframe_src) ? _c('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "src": _vm.props.acf.fb_iframe_src,
      "width": "478px",
      "height": "482px",
      "frameborder": "0",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "scrolling": "no",
      "allow": "encrypted-media"
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "office"
  }, [_c('div', [_c('div', [(_vm.propsheader.acf.phone) ? _c('a', {
    staticClass: "phone",
    attrs: {
      "href": "tel:" + _vm.propsheader.acf.phone,
      "itemprop": "telephone"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.propsheader.acf.phone)
    }
  })]) : _vm._e(), (_vm.propsheader.acf.address_url) ? _c('router-link', {
    staticClass: "addy",
    attrs: {
      "to": _vm.propsheader.acf.address_url
    }
  }, [(_vm.props.acf.map_marker) ? _c('div', {
    staticClass: "icon",
    class: _vm.props.acf.map_marker
  }) : _vm._e(), (_vm.propsheader.acf.address) ? _c('div', {
    staticClass: "street",
    domProps: {
      "innerHTML": _vm._s(_vm.propsheader.acf.address)
    }
  }) : _vm._e()]) : _vm._e()], 1)])])])], 1), _c('div', {
    staticClass: "copyright_section"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "copytext"
  }, [_c('span', [_vm._v("© " + _vm._s(new Date().getFullYear()) + " - ")]), (_vm.props.acf.copyright_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.copyright_text)
    }
  }) : _vm._e(), _c('span', [_vm._v("|          ")]), (_vm.props.acf.sitemap_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.sitemap_url
    }
  }, [(_vm.props.acf.sitemap_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sitemap_text)
    }
  }) : _vm._e()]) : _vm._e()], 1), _c('div', {
    staticClass: "scroll_btn"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#app'),
      expression: "'#app'"
    }],
    attrs: {
      "id": "back-to-top",
      "href": "#"
    }
  }, [_c('u-animate', {
    staticClass: "back_wrap",
    attrs: {
      "name": "tada",
      "delay": "1s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.propsheader.acf.smile_logo) ? _c('img', {
    staticClass: "decoration-bottom",
    attrs: {
      "src": _vm.propsheader.acf.smile_logo,
      "alt": "",
      "width": "63"
    }
  }) : _vm._e()]), (_vm.props.acf.backtotop_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.backtotop_text)
    }
  }) : _vm._e()], 1), (_vm.props.acf.request_an_appointment_url) ? _c('router-link', {
    attrs: {
      "id": "appt-btn",
      "to": _vm.props.acf.request_an_appointment_url
    }
  }, [(_vm.props.acf.request_an_appointment_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.request_an_appointment_text)
    }
  }) : _vm._e()]) : _vm._e()], 1)])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e021312","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 595
// module chunks = 1